import { createContext, ReactNode } from 'react';

export interface FeatureFlags {
  /**
   * Disable SPA navigation.
   *
   * @default true
   */
  DISABLE_SPA_NAVIGATION: boolean;
  /**
   * Disable prefetching of links.
   *
   * @default false
   */
  DISABLE_LINK_PREFETCH: boolean;
}

/**
 * Default feature-flag values
 */
export const DefaultFeatureFlags: FeatureFlags = {
  DISABLE_SPA_NAVIGATION: false,
  DISABLE_LINK_PREFETCH: false,
};

export const FeatureFlagsContext = createContext<FeatureFlags>(DefaultFeatureFlags);

interface FeatureFlagsProviderProps {
  children: ReactNode;
  flags?: Partial<FeatureFlags>;
}

export function FeatureFlagsProvider({ children, flags }: FeatureFlagsProviderProps) {
  return (
    <FeatureFlagsContext.Provider value={{ ...DefaultFeatureFlags, ...flags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}
